module.exports = __webpack_public_path__ + "img/mastercard_footer.6c49de1.svg";